import React, { useState } from "react";

import SmallImageListItem from "./SmallImageListItem";
import styles from "./ImageList.module.css";

/**
 *
 * @typedef {Object} state
 * @prop {number} idx -
 * @prop {"description" | "title"} field
 */

const SmallImageListView = ({ images = [], isLocked, onPropUpdate, moveImage, removeImage }) => {
  const [editingItemId, setEditingItemId] = useState(null);

  const _onPropUpdate = (propInfo) => {
    onPropUpdate && onPropUpdate(propInfo);
  };

  const _removeImage = (idx) => {
    removeImage && removeImage(idx);
  };

  const _onImageMove = (data) => {
    moveImage && !isLocked && moveImage({ ...data, editingItemId });
  };

  const _startEditMode = (itemId) => {
    setEditingItemId(itemId);
  };

  return (
    <div className={styles["image-list"]} data-testid="small-image-list-view">
      {images.map((img, idx) => {
        const itemKey = img.get("key");
        const uniqueItemId = `${itemKey}-${idx}`;
        return (
          <SmallImageListItem
            disabled={isLocked}
            key={uniqueItemId}
            editing={uniqueItemId === editingItemId}
            removeImage={_removeImage}
            image={img}
            index={idx}
            onMoveImage={_onImageMove}
            onPropUpdate={_onPropUpdate}
            onStartEditMode={() => _startEditMode(uniqueItemId)}
          />
        );
      })}
    </div>
  );
};

export default SmallImageListView;
